// @ts-ignore
import styles from "./Alert.module.scss";
import type { AlertProps as AntdAlertProps } from "antd";
import { Alert as AntdAlert } from "antd";
import React, { useEffect, useMemo, useRef } from "react";
// @ts-ignore
import { ReactComponent as InfoCircleIcon } from "bootstrap-icons/icons/info-circle.svg";

export type AlertProps = AntdAlertProps & {
  textColor?: string
}

export const Alert = (props: AlertProps) => {
  const { textColor, ...antdProps } = props;
  const type = props.type || "info";
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!wrapperRef.current) return;
    const messageElem = wrapperRef.current.querySelector("div.ant-alert-message") as HTMLDivElement;
    if (!messageElem) return;

    if (textColor) {
      messageElem.style.setProperty("--alert-message-color", textColor);
      return;
    }
    if (type === "warning") {
      messageElem.style.setProperty("--alert-message-color", "#995415");
    } else if (type === "error") {
      messageElem.style.setProperty("--alert-message-color", "#99120F");
    }
  }, [type, textColor]);

  const icon = useMemo(() => {
    if (!["warning", "info" ].includes(type)) return props.icon;

    return props.icon ?? (
      <InfoCircleIcon
        style={{
          top: 2,
        }}
      />
    );
  }, [type]);

  return (
    <div
      ref={wrapperRef}
      className={styles.alert}
    >
      <AntdAlert
        {...antdProps}
        type={type}
        icon={icon}
      />
    </div>
  );
};
